export default {
  'menu.aiScenes': '應用場景',
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.myApps': '我的應用',
  'menu.markets.apps': '應用市場',
  'menu.markets.skills': 'Skill 市場',
  'menu.markets.mcp': 'MCP 市場',
  'menu.markets.plugins': '插件市場',
  'menu.businessAppMarket': '業務應用市場',
  'menu.management': '企業管理',
  'menu.management.tenants': '租戶管理',
  'menu.management.tenantDetail': '租戶詳情',
  'menu.management.users': '使用者管理',
  'menu.management.userDetail': '使用者詳情',
  'menu.management.myTenants': '租戶設定',
  'menu.management.myTenantDetail': '租戶設定',
  'menu.management.identities': '成員管理',
  'menu.management.departments': '部門管理',
  'menu.management.roles': '權限管理',
  'menu.management.auditLog': '審計日誌',
  'menu.platformManagement': '平台管理',
  'menu.platformManagement.applications': '應用管理',
  'menu.platformManagement.pluginApplications': '外掛應用',
  'menu.platformManagement.applicationPublicationReview': '應用上架審核',
  'menu.platformManagement.taxonomies': '分類法管理',
  'menu.platformManagement.aiRuntime': '模型廣場',
  'menu.platformManagement.events': '事件引擎',
  'menu.platformManagement.clusters': '叢集管理',
  'menu.platformManagement.applicationStorage': '應用儲存配置',
  'menu.platformManagement.productCatalog': '統一商品目錄',
  'menu.platformManagement.tenantPackages': '套餐管理',
  'menu.platformManagement.tenantEntitlements': '租戶權益',
  'menu.platformManagement.paymentOrders': '支付訂單',
  'menu.platformSettings': '平台設定',
  'menu.platformSettings.branding': '品牌',
  'menu.platformSettings.llm': '預設大模型',
  'menu.platformSettings.storage': '預設儲存',
  'menu.platformSettings.quota': '用量限制',
  'menu.platformSettings.features': '平台功能',
  'menu.platformSettings.permissions': '平台權限',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.settings': '系統設置',
  'menu.settings.permissions': '權限管理',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.account.switchTenant': '切換企業',
  'menu.account.switchTenant.empty': '暫無可切換企業',
  'menu.account.switchTenant.create': '創建/加入企業',
  'menu.account.switchTenant.delete': '刪除企業',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
